import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ThemeService } from 'app/services/theme.service';

@Component({
  selector: 'app-select-theme',
  templateUrl: './select-theme.component.html',
  styleUrls: ['./select-theme.component.scss'],
  standalone: true,
  imports:[IonicModule, CommonModule, TranslateModule],
})
export class SelectThemeComponent {
  @Input() fromPage = '';
  protected lightThemeName = 'LIGHT_THEME';
  protected darkThemeName = 'DARK_THEME';
  protected isDarkTheme = false;
  constructor(
    private readonly translate: TranslateService,
    protected themeService: ThemeService,
  ) {
    if (localStorage.getItem('dark')) {
      this.isDarkTheme = true;
    }
  }

  protected ngOnInit() {
    if(this.fromPage && this.fromPage === 'header-desktop') {
      this.lightThemeName = 'LIGHT';
      this.darkThemeName = 'DARK';
    }
  }
}
